import * as React from 'react';
import { ToastContext } from './toast.context';
import type { ToastContextValue } from './toast.context';

export function useToast(): ToastContextValue {
  const ctx = React.useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return ctx;
}

